import { render, staticRenderFns } from "./custom-field.vue?vue&type=template&id=6b715869"
import script from "./custom-field.vue?vue&type=script&lang=js"
export * from "./custom-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b715869')) {
      api.createRecord('6b715869', component.options)
    } else {
      api.reload('6b715869', component.options)
    }
    module.hot.accept("./custom-field.vue?vue&type=template&id=6b715869", function () {
      api.rerender('6b715869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/custom-field.vue"
export default component.exports